<template>
    <MobileTopBar :with_logo="true"/>
    <div class="container">
        <div class="md:mb-10">
            <HomeSlider/>
        </div>
        <div class="mb-5 md:mb-10">
            <ProductCategoriesLinks :jbi_categories="categories.jbi"
                                    :beton_categories="categories.beton"/>
        </div>
        <div class="mb-10" v-if="!themeStore.minimize_ui">
            <HomeAboutBlock/>
        </div>
        <div class="mb-10" v-if="!themeStore.minimize_ui">
            <HomeVideoBlock/>
        </div>
        <!--    <HomeCatalogNavigation/>-->
    </div>
    <div class="md:container max-md:ms-5 mb-5 md:mb-10"
         v-if="!themeStore.minimize_ui">
        <PopularProducts/>
    </div>
    <div class="mb-10"
         v-if="!themeStore.minimize_ui">
        <WhyWeFirst/>
    </div>
    <div class="container"
         v-if="!themeStore.minimize_ui">
        <div class="mb-10">
            <OfficialLicense/>
        </div>
    </div>
    <div class="mb-10" v-if="!themeStore.minimize_ui">
        <Feedbacks/>
    </div>
    <div class="container" v-if="!themeStore.minimize_ui">
        <FaqComponent title="Частые вопросы"
                      subtitle="Остались вопросы? Наши менеджеры всегда готовы ответить!"
                      :items="homeFaqItems"
                      schema-id="schema-home-faq-jsonld"/>
    </div>
</template>

<script>
import {useThemeStore} from "@/js/store/ThemeStore.js";
import OfficialLicense from "@js/components/Sections/Licenses/OfficialLicense.vue";
import WhyWeFirst from "@js/components/Sections/InfoCards/WhyWeFirst.vue";
import WorkingSince from "@js/components/Sections/Home/WorkingSince.vue";
import Feedbacks from "@js/components/Sections/Feedbacks/Feedbacks.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import HomeCatalogNavigation from "@js/components/Sections/Home/HomeCatalogNavigation.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import FaqComponent from "@js/components/Faq/FaqComponent.vue";
import HomeSlider from "@js/components/Sections/PageComponent/Home/HomeSlider.vue";
import HomeAboutBlock from "@js/components/Sections/Home/HomeAboutBlock.vue";
import HomeVideoBlock from "@js/components/Sections/Home/HomeVideoBlock.vue";
import PopularProducts from "@js/components/Sections/Sliders/PopularProducts.vue";
import ProductCategoriesLinks from "@js/components/Sections/PageComponent/Home/ProductCategoriesLinks.vue";

export default {
    name: 'Home',
    props: {
        categories: {
            required: true,
        }
    },
    components: {
        ProductCategoriesLinks,
        PopularProducts,
        HomeVideoBlock,
        HomeAboutBlock,
        HomeSlider,
        FaqComponent,
        MobileTopBar,
        HomeCatalogNavigation,
        OnlyDesktop,
        Feedbacks,
        WorkingSince,
        WhyWeFirst,
        OfficialLicense,
    },
    data() {
        return {
            is_hovered: false,
            isMounted: false,
            homeFaqItems: [
                {
                    question: 'Какое качество бетонных плит вы гарантируете?',
                    answer: 'Все наши бетонные плиты проходят строгий контроль качества. Мы используем только сертифицированные материалы и современные технологии производства, что гарантирует их прочность, долговечность и устойчивость к нагрузкам.',
                },
                {
                    question: 'Как оформить заказ на бетонные плиты?',
                    answer: 'Вы можете оформить заказ через наш сайт, позвонив по телефону или посетив наш офис. Мы готовы проконсультировать вас по выбору плит и помочь рассчитать необходимый объем.',
                },
                {
                    question: 'Как рассчитывается стоимость бетонных плит?',
                    answer: 'Стоимость бетонных плит зависит от их типа, размеров, объема заказа и условий доставки. Мы предлагаем прозрачное ценообразование и скидки для оптовых клиентов.',
                },
                {
                    question: 'Подходят ли ваши бетонные плиты для дорожного строительства?',
                    answer: 'Да, наши дорожные плиты отличаются высокой прочностью и долговечностью, что делает их идеальными для строительства автомобильных дорог, площадок и тротуаров.',
                },
                {
                    question: 'Какие материалы используются для производства бетонных плит?',
                    answer: 'Для производства наших бетонных плит используются высококачественный цемент, песок, щебень и арматура. Все материалы проходят строгий отбор и соответствуют нормативным требованиям.',
                },
            ]
        };
    },
    setup() {
        const themeStore = useThemeStore()

        return {themeStore}
    },
    mounted() {
        this.isMounted = true
    }
};
</script>

<style lang="scss">

</style>
